<template>
  <p class="message-error" v-if="value === 0 || value < min || value > max">
    <template v-if="value === 0">
      {{$t('services.services.errorValueChosen.default')}}
    </template>
    <template v-else-if="min && max">
      {{$t('services.services.errorValueChosen.interval', {min: service.min, max: service.max})}}
    </template>
    <template v-else-if="min">
      {{$t('services.services.errorValueChosen.min', {min: service.min})}}
    </template>
    <template v-else-if="max">
      {{$t('services.services.errorValueChosen.max', {max: service.max})}}
    </template>
  </p>
</template>

<script>
export default {
  name: 'GenerateError',
  props: {
    value: {
      type: Number,
      default: 0,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style scoped lang="scss">
.message-error {
  color: var(--nxt-color-danger);
  font-weight: 500;
}
</style>
